import {FinanceRelanceRecordSection} from './finance-relance-record-section.enum';
import {FinanceRelanceRecordType} from './finance-relance-record-type.enum';

export class FinanceRelanceRecord {
	id?: number;
	amount: number;
	description: string;
	section: FinanceRelanceRecordSection;
	type: FinanceRelanceRecordType;
	disableDescription?: boolean;
	unitsYear1?: number;
	unitsYear2?: number;
	unitsYear3?: number;

	constructor(obj: any = {}) {
		this.id = obj.id;
		this.amount = obj.amount;
		this.description = obj.description;
		this.section = obj.section;
		this.type = obj.type;
		this.unitsYear1 = obj.unitsYear1;
		this.unitsYear2 = obj.unitsYear2;
		this.unitsYear3 = obj.unitsYear3;
	}
}
